import services from "../services";

export const traceManagementActions = {
  searchTraceQueue,
  closeTraceQueue,
  sendTraceQueue,
  readTraceMessages
};



function searchTraceQueue(values, props) {
  return services.traceQueueService.searchTraceQueue(values, props);
}

// function closeTrace(values, props) {
//   return services.traceQueueService.closeTraceQueue(values,props);
// }

function closeTraceQueue(values, props) {
  return services.traceQueueService.closeTraceQueue(
      values,
      props
  );
}

function sendTraceQueue(values, props) {
  return services.traceQueueService.sendTraceQueue(
      values,
      props
  );
}

function readTraceMessages(values, props) {
  return services.traceQueueService.readTraceMessages(
      values,
      props
  );
}
  
